<template>
    <div height="medium" width="large">
        <h2 class="heading">{{ $t('modals.sidebarList.content.accident_intake') }}</h2>
        <intake-wizard
            type="accident"
            :patientDetails="patientDetails"
            :patientId="patientId"
            :authenticated="authenticated"
            v-on="$listeners"
        ></intake-wizard>
    </div>
</template>

<script>
    import IntakeWizard from 'components/forms/IntakeWizard'

    export default {
        components: {
            IntakeWizard,
        },

        props: {
            patientDetails: {
                type: Object,
                default: null,
            },
            patientId: {
                type: [String, Number],
                default: null,
            },
            authenticated: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>
<style scoped lang="scss">
    .heading {
        font-size: 16px;
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
        margin-bottom: 14px;
    }
</style>
